import { cn } from "@/lib/utils";

interface QuestCardProps {
  children: React.ReactNode;
  className?: string;
}

export const QuestCard: React.FC<QuestCardProps> = ({ children, className }) => (
  <div
    className={cn(
      "relative rounded-3xl p-px",
      "bg-gradient-to-br from-indigo-400/80 via-border-secondary to-emerald-400/50",
      "dark:from-indigo-400/50 dark:via-gray-600/60 dark:to-emerald-400/30",
      "shadow-[0_24px_64px_-20px_rgba(79,70,229,0.45)]",
      "dark:shadow-[0_24px_64px_-20px_rgba(99,102,241,0.55)]",
      className
    )}
  >
    <div className="relative overflow-hidden rounded-[23px] bg-white dark:bg-gray-800">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-indigo-50/90 via-transparent to-emerald-50/40 dark:from-indigo-500/15 dark:via-transparent dark:to-emerald-500/10" />
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-indigo-300/30 blur-3xl dark:bg-indigo-500/20" />
      <div className="relative p-5 sm:p-7 md:p-8">{children}</div>
    </div>
  </div>
);
